var _effectorFileName = "/src/page-content/home/components/how-work-starts/how-work-starts.tsx";
import { useUnit } from 'effector-react';
import { useTranslation } from 'next-i18next';
import { Article } from '@/shared/components/article';
import { CardCustom } from '@/shared/components/card-custom';
import { ContactForm } from '@/shared/components/contact-form';
import { $isContactFormSentSuccessfully, contactFormDataSent } from '@/shared/components/contact-form/model';
import { ContactFormData } from '@/shared/components/contact-form/types';
import { LineWithCircles } from '@/shared/components/line-with-circles';
import { TextGradient } from '@/shared/components/text-gradient';
import { HOW_WORK_STARTS_LIST } from '../../constants/how-work-starts';
export const HowWorkStarts = () => {
  const {
    t
  } = useTranslation('home-how-work-starts');
  const {
    isContactFormSentSuccessfully,
    onContactFormSend
  } = useUnit({
    isContactFormSentSuccessfully: $isContactFormSentSuccessfully,
    onContactFormSend: contactFormDataSent
  });
  const handleContactFormSubmit = (data: ContactFormData) => {
    onContactFormSend(data);
  };
  return <Article>
      <div className="grid grid-cols-1 items-center gap-y-6 md:gap-x-20 lg:grid-cols-[1fr_minmax(200px,_50%)] xl:grid-cols-[1fr_minmax(200px,_40%)]">
        <div className="mx-auto sm:mx-0">
          <LineWithCircles className="mb-10">
            {HOW_WORK_STARTS_LIST.map((step, index) => <div key={index}>
                <h3 className="mb-3 header-h3 sm:mb-5">{t(step.titleKey)}</h3>

                <p className="text-sm text-muted-foreground" dangerouslySetInnerHTML={{
              __html: t(step.descriptionKey)
            }} />
              </div>)}
          </LineWithCircles>

          <p className="max-w-3xl text-muted-foreground" dangerouslySetInnerHTML={{
          __html: t('footer')
        }} />
        </div>

        <CardCustom isCardDataSentSuccessfully={isContactFormSentSuccessfully}>
          <TextGradient text={t('form.title')} className="mb-1.5 text-center text-2xl font-medium !tracking-tight" />

          <p className="mb-6 text-center text-muted-foreground">{t('form.subtitle')}</p>

          <ContactForm buttonText={t('form.buttonText')} onFormSubmit={handleContactFormSubmit} />
        </CardCustom>
      </div>
    </Article>;
};